import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  LogoutDialogContext,
  EmptyDialog,
} from "../context/LogoutDialogContext";
import { routes } from "../router/MyRoutes";

export default function DialogLogout() {
  const [open, setOpen] = useState(false);
  const { logoutDialog, setLogoutDialog } = useContext(LogoutDialogContext);
  const navigate = useNavigate();

  useEffect(() => {
    setOpen(logoutDialog.isOpen);
  }, [logoutDialog]);

  const handleClose = () => {
    setLogoutDialog(EmptyDialog);
    setOpen(logoutDialog.isOpen);
    navigate(routes.login.path);
  };

  return (
    <>
      <Dialog open={open} onClose={handleClose} maxWidth="lg">
        <DialogTitle id="logout-dialog-title">{logoutDialog.title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="logout-dialog-description">
            {logoutDialog.content}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleClose}>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
